import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`GIF Blocking Tool`}</h2>
    <p>{`Developers using GIPHY are able to customize their user experience by implementing a maximum `}<a parentName="p" {...{
        "href": "https://developers.giphy.com/docs/optional-settings#rating"
      }}>{`Content Rating`}</a>{` for their integration.
In addition to this we also provide a GIF Blocking tool to remove content that falls within the selected `}<a parentName="p" {...{
        "href": "https://developers.giphy.com/docs/optional-settings#rating"
      }}>{`Content Rating`}</a>{` range, if desired.
As a result, your moderation teams have more control over the integration too.`}</p>
    <p>{`The GIF Blocking Tool can be accessed from the API key details page and accepts GIF IDs.
Once added via this tool these GIFs will not be returned via the GIPHY API.
Change your mind? You can also remove GIF IDs using the tool.
Please allow up to 24 hours for changes to apply.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      